
    import '/opt/buildhome/repo/packages/x/docs/x-markdown/demo/codeDemo/plugin.md?watch=parent';
    export const toc = [{"id":"zh-cn","depth":2,"title":"zh-CN"},{"id":"en-us","depth":2,"title":"en-US"}];
export const frontmatter = {"title":"Plugin","toc":"menu","filename":"docs/x-markdown/demo/codeDemo/plugin.md","lastUpdated":1764733616000,"description":"渲染自定义标记[^1]。"};